import { Vue } from 'vue-property-decorator'
import { ServiceRequestListRepository } from './ServiceRequestListRepository'
import { JtechStore } from 'src/plugins/mobx'
import ServiceRequestModel from '../../../ServiceRequestModel'

export default class ServiceRequestListController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestListController', new ServiceRequestListController())
  }

  async loadDatatable () {
    return await ServiceRequestListRepository.loadDatatable()
  }

  async loadDatatableModel (params) {
    return await ServiceRequestListRepository.loadDatatableModel(params)
  }
}
